import type { Group } from "@/group";
import { t } from "@/i18n";
import { showSnackbar } from "@/snackbar/snackbar";
import { SNACKBAR_TIMEOUT } from "../constants/aiConstants";
import { checkIsWidgetsQuantityExceeded } from "./checkIsWidgetsQuantityExceeded";

export function checkWidgetsForAi(widgets: Group[]) {
    const isWidgetsQuantityExceeded = checkIsWidgetsQuantityExceeded(widgets);

    if (isWidgetsQuantityExceeded) {
        showSnackbar(t("ai.maxWidgets"), { duration: SNACKBAR_TIMEOUT });
    }

    return isWidgetsQuantityExceeded;
}
